import { render, staticRenderFns } from "./Corp.vue?vue&type=template&id=3d2e7993"
import script from "./Corp.vue?vue&type=script&lang=ts"
export * from "./Corp.vue?vue&type=script&lang=ts"
import style0 from "./Corp.vue?vue&type=style&index=0&id=3d2e7993&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports